import React from 'react';
import {
  Breadcrumb, BreadcrumbItem, Card, CardFooter, CardHeader, Col, Row, Table,
} from 'reactstrap';

import { AdminTablePlaceholderRows } from './AdminTablePlaceholder';

const DETAIL_ROW_KEYS = [...Array(8)].map((_, index) => `detail-row-${index + 1}`);
const RELATED_COLUMN_KEYS = [...Array(5)].map((_, index) => `related-column-${index + 1}`);

/**
 * Skeleton placeholder for admin show routes (AdminCommunityShow, AdminMeterShow, etc.).
 * Mirrors the shared admin show layout — breadcrumb, page heading, a narrow
 * details card of label/value rows, and a wide card with a table — shown when a
 * field or network error on the route query is caught by PlaceholderErrorBoundary.
 * @returns {React.ReactElement} AdminShowPlaceholder component.
 */
function AdminShowPlaceholder() {
  return (
    <div aria-hidden="true" data-testid="admin-show-placeholder">
      <Breadcrumb>
        <BreadcrumbItem>
          <span className="placeholder placeholder-glow bg-darken" style={{ width: '3rem' }} />
        </BreadcrumbItem>
        <BreadcrumbItem>
          <span className="placeholder placeholder-glow bg-darken" style={{ width: '5.5rem' }} />
        </BreadcrumbItem>
        <BreadcrumbItem>
          <span className="placeholder placeholder-glow bg-darken" style={{ width: '8rem' }} />
        </BreadcrumbItem>
      </Breadcrumb>
      <h1>
        <span className="placeholder placeholder-glow bg-darken" style={{ width: '12rem' }} />
      </h1>

      <Row className="clear-both">
        <Col xs={12} sm={6} md={4}>
          <Card data-testid="admin-show-placeholder-details">
            <CardHeader>
              <span className="placeholder placeholder-glow bg-darken col-6" />
            </CardHeader>
            <Table responsive>
              <tbody>
                {DETAIL_ROW_KEYS.map((key) => (
                  <tr key={key}>
                    <th scope="row" className="text-right">
                      <span className="placeholder placeholder-glow bg-darken col-8" />
                    </th>
                    <td>
                      <span className="placeholder placeholder-glow bg-darken col-10" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        </Col>

        <Col xs={12} sm={6} md={8}>
          <Card data-testid="admin-show-placeholder-related">
            <CardHeader>
              <span className="placeholder placeholder-glow bg-darken col-3" />
            </CardHeader>
            <Table responsive>
              <thead>
                <tr>
                  {RELATED_COLUMN_KEYS.map((key) => (
                    <th key={key} scope="col">
                      <span className="placeholder placeholder-glow bg-darken col-6" />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <AdminTablePlaceholderRows rowCount={5} />
              </tbody>
            </Table>
            <CardFooter>
              <span className="placeholder placeholder-glow bg-darken btn btn-sm" style={{ width: '6rem' }} />
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default AdminShowPlaceholder;
